import { Button } from 'rsuite';

interface Props {
  title: string;
  onClick: () => void;
}

const SecondaryButton = (props: Props) => {
  return (
    <Button variant="light" size="sm" radius="lg" onClick={props.onClick}>
      {props.title}
    </Button>
  );
};

export { SecondaryButton };
